import React from "react";
import styles from "./VisionDissatisfaction.module.css";

export default function EdofLensPromo() {
  return (
    <div className={styles.containerMain}>
      <div className={styles.container}>
        <div className={styles.Box}>
          <div className={styles.part}>
            <div className={styles.imgDiv}>
              <img src="Images/Happy -Eye-icon.webp" alt="icon representing Deseyne® delivering next-generation soft contact lenses for all prescriptions" loading="lazy" decoding="async" />
            </div>

            <p>Delivering <span className={styles.diffrentcolor}>next-gen </span>
              soft contact lenses for every prescription
            </p>
          </div>
          <div className={styles.part}>
          <div className={styles.imgDiv}>
              <img src="Images/World-Wide-icon.webp" alt="icon Deseyne® Available worldwide" loading="lazy" decoding="async" />

            </div>
            <p>Available <span className={styles.diffrentcolor}>
              worldwide </span>

            </p>
          </div>
          <div className={styles.part}>
          <div className={styles.imgDiv}>
              <img src="Images/1Billion-icon.webp" alt="Icon representing Deseyne® manufacturing over one billion contact lenses annually" loading="lazy" decoding="async" />

            </div>
            <p>  Manufacturing over <span className={styles.diffrentcolor}>one billion </span>
              contact
              lenses annually
            </p>
          </div>
          <div className={styles.part}>
             <div className={styles.imgDiv}>
            <img src="Images/Leader-icon.webp" alt="Deseyne® Leader in soft contact lens innovation icon" loading="lazy" decoding="async" />

             </div>
            <p><span className={styles.diffrentcolor}>Leader </span>
              in soft contact lens innovation
            </p>
          </div>

        </div>
      </div>
    </div>

  );
}
